import { render } from "./DeleteItemDialog.vue?vue&type=template&id=f6fbd41a"
import script from "./DeleteItemDialog.vue?vue&type=script&lang=js"
export * from "./DeleteItemDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__